import types from "../types";
import { push } from "../../router/history";
import {
  showSuccessSnackbar,
  showFailSnackbar,
} from "../../common/actions/snackbar";

export function createUser(values) {
  return async (dispatch) => {
    values.email.trim();

    return dispatch({
      type: types.CREATE,
      payload: {
        request: {
          url: `users/create`,
          method: "POST",
          data: values,
        },
      },
    })
      .then(async ({ payload }) => {
        push("user-list");
        dispatch(
          showSuccessSnackbar(
            "Sucesso! O usuário receberá um email para realizar o cadastro de sua senha."
          )
        );
      })
      .catch((error) => {
        console.log("error---", error);
        dispatch(
          showFailSnackbar("Ops! Algo deu errado, tente novamente mais tarde.")
        );
      });
  };
}

export function createInitialPassword(values, token) {
  return async (dispatch) => {
    let value = {};

    values.password.trim();

    value = {
      password: values.password,
    };
    return dispatch({
      type: types.CREATE_PASSWORD,
      payload: {
        request: {
          url: `create-password/${token}`,
          method: "POST",
          data: value,
        },
      },
    })
    .then(async ({ payload }) => {
      push("/");
      })

      .catch((error) => {
        console.log("error---", error);
      });
  };
}
